import ScreenNotificationCategoryUpdate from 'screens/NotificationCategory/Update';
import ScreenNotificationCategoryCreate from 'screens/NotificationCategory/Create';
import ScreenNotificationCategoryList from 'screens/NotificationCategory/List';
import { NOTIFICATION_CATEGORY } from 'routes/paths';

const notificationCategoryRoutes = [
  {
    path: NOTIFICATION_CATEGORY.UPDATE,
    name: 'NotificationCategoryUpdate',
    component: ScreenNotificationCategoryUpdate,
    allowPermissions: ['change_notificationcategory'],
  },
  {
    path: NOTIFICATION_CATEGORY.CREATE,
    name: 'NotificationCategoryCreate',
    component: ScreenNotificationCategoryCreate,
    allowPermissions: ['add_notificationcategory'],
  },
  {
    path: NOTIFICATION_CATEGORY.LIST,
    name: 'NotificationCategoryList',
    component: ScreenNotificationCategoryList,
    loginRequired: true,
    allowPermissions: ['list_notificationcategory'],
  },
];

export default notificationCategoryRoutes;
